<template>
  <div
    :class="{
      'minimal-root': isMinimalView,
      'branded-root': isBrandedNavView,
    }"
  >
    <dashboard-new v-if="isFullView">
      <template v-slot:header>
        <toolbar-core />
      </template>
      <template v-slot:body>
        <div
          class="classContainerBodySlot"
          style="width: calc(100vw); height: calc(100vh - 190px); overflow: auto;"
        >
          <v-container>
            <div class="headerMainContent">
              <div class="d-flex align-center">
                <v-btn
                  icon
                  large
                  class="mr-4"
                  @click="goBack"
                >
                  <v-icon size="32">mdi-arrow-left</v-icon>
                </v-btn>
                <div class="headerMainContentModuleName">
                  <h1 class="tittleMyProfile2">
                    {{ data.module.name }}
                  </h1>
                  <p class="titleMyProfile">
                    Módulo
                  </p>
                </div>
              </div>
            </div>
         
            <div v-if="!showNoContent">
              <v-card
                class="stylingContainerDynamic"
                :height="data.file_type == 'audio' ? 500 : 'auto'"
                color="#EEEEEE"
              >
                <div class="headerInsideShowContentDad">
                  <div class="headerInsideShowContent">
                    <span class="headerInsideShowContent_title">
                      {{ data.pill_name }}
                    </span>
                    <span class="headerInsideShowContent_timestamp">
                      Enviado {{ data.created_at | date }}
                    </span>
                  </div>
                 
                  <div class="headerInsideShowContent2">
                    <div class="buttons-container">
                      <button 
                        class="btnEditProfile2" 
                        @click="openQuestions" 
                        :disabled="loading"
                      >
                        <v-icon>mdi-help-circle-outline</v-icon> Preguntas <span v-if="data.count_questions">({{ data.count_questions }})</span> 
                      </button>

                      <button 
                        class="btnEditProfile2" 
                        @click="openAttachments" 
                        :disabled="loading"
                      >
                        <v-icon>mdi-paperclip</v-icon> Adjuntos   <span v-if="data.count_attachments">({{ data.count_attachments }})</span>
                      </button>

                      <button 
                        v-if="isVideoPollsFeatureEnabled"
                        class="btnEditProfile2" 
                        @click="openPolls" 
                        :disabled="loading || !canUseVideoPolls"
                      >
                        <v-icon>mdi-poll</v-icon> Encuestas <span v-if="videoPolls.length">({{ answeredPollIds.length }}/{{ videoPolls.length }})</span>
                      </button>
                    </div>

                    <span class="headerInsideShowContent_timestamp">
                      Formato {{ data.file_type || "Analizando" }}
                    </span>
                  </div>
                </div>
                <v-card-text v-if="isMediaType">
                  <show-content-media
                    ref="contentMedia"
                    :data="data"
                    :loading="loading"
                    :file-type="file_type"
                    :show-rotation-ct="showRotationCt"
                    :is-minimal-view="false"
                    :fullscreen="fullscreen"
                    :schedule-id="schedule_id"
                    :notes="videoNotes"
                    :polls="videoPolls"
                    :answered-poll-ids="answeredPollIds"
                    @fullscreen-change="fullscreenChange"
                    @time-update="handleVideoTimeUpdate"
                    @video-ended="handleVideoEnded"
                    @open-notes="openNotes"
                    @open-polls="openPolls"
                  >
                    <template v-if="canUseVideoNotes" v-slot:video-actions>
                      <button
                        class="video-note-trigger"
                        type="button"
                        @mousedown.stop
                        @touchstart.stop
                        @click.stop="openNoteComposer"
                      >
                        <v-icon size="18">mdi-note-plus-outline</v-icon>
                        <span>Nota</span>
                      </button>
                    </template>
                  </show-content-media>
                </v-card-text>
                <v-card-text v-if="data.file_type == 'articulo'">
                  <h3>Por favor click en el siguiente boton</h3>
                  <v-btn
                    color="#0DB2D2"
                    dark
                    class="mt-5"
                    @click="HandlerRedirect(data.file_upload)"
                    >información del articulo</v-btn
                  >
                </v-card-text>
                <v-card-text
                  v-else-if="
                    data.file_type == 'test_content' ||
                      data.file_type == 'cuestionario'
                  "
                >
                  <h3 v-if="!evaluationScore || evaluationScore === ''">Complete la siguiente información</h3>
                  <h3 v-else>Resultado de la evaluación: {{ evaluationScore }} de 100</h3>
                  <div
                    v-for="(item, index) in data.question"
                    :key="index"
                    class="mt-5"
                  >
                    <span class="font-weight-bold">
                      {{ `${index + 1}- ${item.name}` }}
                    </span>
                    <template v-if="item.question_type === 'single_selection'">
                      <v-radio-group
                        v-model="item.created_at"
                      >
                        <v-radio
                          v-for="(value, key) in item.answers"
                          :key="key"
                          :label="evaluationScore && evaluationScore !== '' 
                            ? `${value.name.toLowerCase()} ${value.status === 1 ? ' (Correcta)' : ''}` 
                            : value.name.toLowerCase()"
                          :value="value.id"
                          @change="HandlerGetValue(value, index)"
                        ></v-radio>
                      </v-radio-group>
                      <p class="sutil-text">Solo una respuesta es válida.</p>
                    </template>
                    <template v-else-if="item.question_type === 'multiple_selection'">
                      <v-checkbox
                        v-for="(value, key) in item.answers"
                        :key="key"
                        :label="evaluationScore && evaluationScore !== '' 
                          ? `${value.name.toLowerCase()} ${value.status === 1 ? ' (Correcta)' : ''}` 
                          : value.name.toLowerCase()"
                        v-model="value.checkbox"
                        @change="HandlerGetValueCuestionary(value, index)"
                      ></v-checkbox>
                      <p class="sutil-text">Puede seleccionar más de una respuesta válida.</p>
                    </template>
                    <template v-else>
                      <p>Tipo de pregunta no reconocido.</p>
                    </template>
                  </div>
                  <v-btn
                    v-if="data.file_type == 'test_content'"
                    color="#20B8D6"
                    dark
                    @click="HandlerSendAnswer"
                    :disabled="evaluationScore !== '' || submittingAnswer"
                    :loading="submittingAnswer"
                  >
                    Enviar
                  </v-btn>
                  <v-btn
                    v-else
                    color="#20B8D6"
                    dark
                    @click="HandlerSendAnswerCuestionary"
                    :disabled="evaluationScore !== '' || submittingAnswer"
                    :loading="submittingAnswer"
                  >
                    Enviar
                  </v-btn>
                </v-card-text>
              </v-card>
            </div>
            <v-row v-else class="mb-15 pb-15" justify="center">
              <v-col cols="12" md="8">
                <v-card height="400" color="#EEEEEE">
                  <v-card flat color="white elevation-0">
                    <v-card-text>
                      <div class="my-5">
                        <p class="headline">
                          Parece que este contenido no esta habilitado
                        </p>
                      </div>
                    </v-card-text>
                  </v-card>
                  <v-card-text>
                    <v-alert
                      class="mt-15 px-15"
                      outlined
                      type="warning"
                      prominent
                      border="left"
                    >
                      No posee este contenido.
                    </v-alert>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <div class="nav-lessons-bar">
              <button
                class="containerBtn--seeRigthNow btn-nav-left"
                @click="navigatePrevLesson"
                :disabled="!prev_lesson"
              >
                <v-icon class="mr-2" color="white">mdi-arrow-left</v-icon>
                <span class="btn-nav-text">Anterior</span>
              </button>
              <button
                class="containerBtn--seeRigthNow btn-nav-right"
                @click="navigateNextLesson"
                :disabled="!canNavigateNextLesson"
              >
                <span class="btn-nav-text">Siguiente</span>
                <v-icon class="ml-2" color="white">mdi-arrow-right</v-icon>
              </button>
            </div>
            <v-row justify="center" class="support-section">
              <v-col cols="12" md="10">
                <ContentRating
                  v-model="rating"
                  :average="rating_general"
                  :can-rating="canRating"
                  :loading="loadingRating"
                  @submit="HandlerRating"
                />
              </v-col>
              <v-col cols="12" md="10">
                <ContentComments
                  ref="contentComments"
                  v-model="commentary"
                  :show-form="showCommentary"
                  :comments="dataCommentaries"
                  :loading="loadingCommentary"
                  :can-load-more="canLoadMoreComments"
                  :pagination="pagination"
                  @update:show-form="showCommentary = $event"
                  @submit="HandlerRegisterCommentary"
                  @page-change="HandlerGetCommentary"
                />
              </v-col>
            </v-row>
          </v-container>
        </div>
      </template>
    </dashboard-new>

    <div v-else-if="isBrandedNavView" class="branded-content-view">
      <header class="branded-header">
        <div class="branded-header-left">
          <v-btn
            icon
            large
            class="branded-back-button mr-2"
            aria-label="Volver"
            @click="goBack"
          >
            <v-icon size="32">mdi-arrow-left</v-icon>
          </v-btn>
          <div class="branded-header-titles">
            <h1 class="branded-lesson-name">
              {{ data.pill_name }}
            </h1>
            <p class="branded-module-name">
              {{ data.module && data.module.name }}
            </p>
          </div>
        </div>
        <div class="branded-support-actions">
          <button
            class="lesson-action-chip"
            @click="openQuestions"
            :disabled="loading || !data.id || !data.module_id"
          >
            <v-icon size="16">mdi-help-circle-outline</v-icon>
            <span>Preguntas</span>
            <small v-if="data.count_questions">><strong>({{ data.count_questions }})</strong></small>
          </button>
          <button
            class="lesson-action-chip"
            @click="openAttachments"
            :disabled="loading || !data.id"
          >
            <v-icon size="16">mdi-paperclip</v-icon>
            <span> Adjuntos</span>
            <small v-if="data.count_attachments"><strong>({{ data.count_attachments }})</strong></small>
          </button>
          <button
            class="lesson-action-chip"
            @click="openComments"
            :disabled="loading || !data.id"
          >
            <v-icon size="16">mdi-comment-outline</v-icon>
            <span>Comentarios</span>
          </button>
          <button
            class="lesson-action-chip"
            @click="openRating"
            :disabled="loading || !data.id"
          >
            <v-icon size="16">mdi-star-outline</v-icon>
            <span>Rating</span>
          </button>
          <button
            v-if="canUseVideoNotes"
            class="lesson-action-chip"
            @click="openNotes"
            :disabled="loading"
          >
            <v-icon size="16">mdi-note-text-outline</v-icon>
            <span>Notas</span>
            <small v-if="totalVideoNotes">({{ totalVideoNotes }})</small>
          </button>
          <button
            v-if="isVideoPollsFeatureEnabled"
            class="lesson-action-chip"
            @click="openPolls"
            :disabled="loading || !canUseVideoPolls"
          >
            <v-icon size="16">mdi-poll</v-icon>
            <span>Encuestas</span>
            <small v-if="videoPolls.length">({{ answeredPollIds.length }}/{{ videoPolls.length }})</small>
          </button>
        </div>
        <v-img
          contain
          :src="brandLogoUrl"
          max-height="48"
          max-width="180"
          class="branded-logo"
        />
        <v-btn
          icon
          large
          class="course-menu-button"
          aria-label="Abrir contenido del curso"
          @click="showCourseSidebar = true"
        >
          <v-icon size="30">mdi-menu</v-icon>
        </v-btn>
      </header>

      <div
        class="branded-body"
        :class="{ 'branded-body--non-video': brandedBodyNonVideoMargin }"
      >
        <v-progress-circular
          v-if="loading"
          size="120"
          indeterminate
          color="primary"
          class="minimal-page-loader"
        />
        <template v-else-if="!showNoContent">
          <show-content-media
            v-if="isMediaType"
            ref="contentMedia"
            :data="data"
            :loading="loading"
            :file-type="file_type"
            :show-rotation-ct="showRotationCt"
            :is-minimal-view="false"
            :is-branded-view="true"
            :fullscreen="fullscreen"
            :schedule-id="schedule_id"
            :notes="videoNotes"
            :polls="videoPolls"
            :answered-poll-ids="answeredPollIds"
            @fullscreen-change="fullscreenChange"
            @time-update="handleVideoTimeUpdate"
            @video-ended="handleVideoEnded"
            @open-notes="openNotes"
            @open-polls="openPolls"
          >
            <template v-if="canUseVideoNotes" v-slot:video-actions>
              <button
                class="video-note-trigger"
                type="button"
                @mousedown.stop
                @touchstart.stop
                @click.stop="openNoteComposer"
              >
                <v-icon size="18">mdi-note-plus-outline</v-icon>
                <span>Nota</span>
              </button>
            </template>
          </show-content-media>
          <div v-if="data.file_type == 'articulo'" class="pa-4 minimal-articulo">
            <v-btn
              color="#0DB2D2"
              dark
              block
              @click="HandlerRedirect(data.file_upload)"
            >
              Información del articulo
            </v-btn>
          </div>
          <v-card
            v-else-if="data.file_type == 'test_content' || data.file_type == 'cuestionario'"
            flat
            class="minimal-quiz pa-4"
          >
            <h3 v-if="!evaluationScore || evaluationScore === ''">Complete la siguiente información</h3>
            <h3 v-else>Resultado de la evaluaci?n: {{ evaluationScore }} de 100</h3>
            <div
              v-for="(item, index) in data.question"
              :key="index"
              class="mt-5"
            >
              <span class="font-weight-bold">
                {{ `${index + 1}- ${item.name}` }}
              </span>
              <template v-if="item.question_type === 'single_selection'">
                <v-radio-group v-model="item.created_at">
                  <v-radio
                    v-for="(value, key) in item.answers"
                    :key="key"
                    :label="evaluationScore && evaluationScore !== ''
                      ? `${value.name.toLowerCase()} ${value.status === 1 ? ' (Correcta)' : ''}`
                      : value.name.toLowerCase()"
                    :value="value.id"
                    @change="HandlerGetValue(value, index)"
                  />
                </v-radio-group>
                <p class="sutil-text">Solo una respuesta es v?lida.</p>
              </template>
              <template v-else-if="item.question_type === 'multiple_selection'">
                <v-checkbox
                  v-for="(value, key) in item.answers"
                  :key="key"
                  :label="evaluationScore && evaluationScore !== ''
                    ? `${value.name.toLowerCase()} ${value.status === 1 ? ' (Correcta)' : ''}`
                    : value.name.toLowerCase()"
                  v-model="value.checkbox"
                  @change="HandlerGetValueCuestionary(value, index)"
                />
                <p class="sutil-text">Puede seleccionar más de una respuesta válida.</p>
              </template>
              <template v-else>
                <p>Tipo de pregunta no reconocido.</p>
              </template>
            </div>
            <v-btn
              v-if="data.file_type == 'test_content'"
              color="#20B8D6"
              dark
              @click="HandlerSendAnswer"
              :disabled="evaluationScore !== '' || submittingAnswer"
              :loading="submittingAnswer"
            >
              Enviar
            </v-btn>
            <v-btn
              v-else
              color="#20B8D6"
              dark
              @click="HandlerSendAnswerCuestionary"
              :disabled="evaluationScore !== '' || submittingAnswer"
              :loading="submittingAnswer"
            >
              Enviar
            </v-btn>
          </v-card>
        </template>
        <div v-else class="minimal-no-content d-flex justify-center align-center">
          <v-alert outlined type="warning" prominent border="left">
            No posee este contenido.
          </v-alert>
        </div>
        <div class="branded-mobile-video-nav" aria-label="Navegacion de lecciones">
          <button
            class="branded-mobile-video-nav__button branded-mobile-video-nav__button--prev"
            type="button"
            @click="navigatePrevLesson"
            :disabled="!prev_lesson"
            aria-label="Leccion anterior"
          >
            <v-icon size="28">mdi-chevron-left</v-icon>
          </button>
          <button
            class="branded-mobile-video-nav__button branded-mobile-video-nav__button--next"
            type="button"
            @click="navigateNextLesson"
            :disabled="!canNavigateNextLesson"
            aria-label="Siguiente leccion"
          >
            <v-icon size="28">mdi-chevron-right</v-icon>
          </button>
        </div>
      </div>

      <div class="branded-nav-bar">
        <button
          class="containerBtn--seeRigthNow btn-nav-left"
          @click="navigatePrevLesson"
          :disabled="!prev_lesson"
        >
          <v-icon class="mr-2" color="white">mdi-arrow-left</v-icon>
          <span class="btn-nav-text">Anterior</span>
        </button>
        <button
          class="containerBtn--seeRigthNow btn-nav-right"
          @click="navigateNextLesson"
          :disabled="!canNavigateNextLesson"
        >
          <span class="btn-nav-text">Siguiente</span>
          <v-icon class="ml-2" color="white">mdi-arrow-right</v-icon>
        </button>
      </div>
    </div>

    <div v-else-if="isMinimalView" class="minimal-content-view">
      <v-progress-circular
        v-if="loading"
        size="120"
        indeterminate
        color="primary"
        class="minimal-page-loader"
      />
      <template v-else-if="!showNoContent">
        <show-content-media
          v-if="isMediaType"
          ref="contentMedia"
          :data="data"
          :loading="loading"
          :file-type="file_type"
          :show-rotation-ct="showRotationCt"
          :is-minimal-view="true"
          :fullscreen="fullscreen"
          :schedule-id="schedule_id"
          :notes="videoNotes"
          :polls="videoPolls"
          :answered-poll-ids="answeredPollIds"
          @fullscreen-change="onMinimalFullscreenChange"
          @time-update="handleVideoTimeUpdate"
          @video-ended="handleVideoEnded"
          @open-notes="openNotes"
          @open-polls="openPolls"
        >
          <template v-if="canUseVideoNotes" v-slot:video-actions>
            <button
              class="video-note-trigger"
              type="button"
              @mousedown.stop
              @touchstart.stop
              @click.stop="openNoteComposer"
            >
              <v-icon size="18">mdi-note-plus-outline</v-icon>
              <span>Nota</span>
            </button>
          </template>
        </show-content-media>
        <div v-if="data.file_type == 'articulo'" class="pa-4 minimal-articulo">
          <v-btn
            color="#0DB2D2"
            dark
            block
            @click="HandlerRedirect(data.file_upload)"
          >
            Información del articulo
          </v-btn>
        </div>
        <v-card
          v-else-if="data.file_type == 'test_content' || data.file_type == 'cuestionario'"
          flat
          class="minimal-quiz pa-4"
        >
          <h3 v-if="!evaluationScore || evaluationScore === ''">Complete la siguiente información</h3>
          <h3 v-else>Resultado de la evaluación: {{ evaluationScore }} de 100</h3>
          <div
            v-for="(item, index) in data.question"
            :key="index"
            class="mt-5"
          >
            <span class="font-weight-bold">
              {{ `${index + 1}- ${item.name}` }}
            </span>
            <template v-if="item.question_type === 'single_selection'">
              <v-radio-group v-model="item.created_at">
                <v-radio
                  v-for="(value, key) in item.answers"
                  :key="key"
                  :label="evaluationScore && evaluationScore !== ''
                    ? `${value.name.toLowerCase()} ${value.status === 1 ? ' (Correcta)' : ''}`
                    : value.name.toLowerCase()"
                  :value="value.id"
                  @change="HandlerGetValue(value, index)"
                />
              </v-radio-group>
              <p class="sutil-text">Solo una respuesta es válida.</p>
            </template>
            <template v-else-if="item.question_type === 'multiple_selection'">
              <v-checkbox
                v-for="(value, key) in item.answers"
                :key="key"
                :label="evaluationScore && evaluationScore !== ''
                  ? `${value.name.toLowerCase()} ${value.status === 1 ? ' (Correcta)' : ''}`
                  : value.name.toLowerCase()"
                v-model="value.checkbox"
                @change="HandlerGetValueCuestionary(value, index)"
              />
              <p class="sutil-text">Puede seleccionar más de una respuesta válida.</p>
            </template>
            <template v-else>
              <p>Tipo de pregunta no reconocido.</p>
            </template>
          </div>
          <v-btn
            v-if="data.file_type == 'test_content'"
            color="#20B8D6"
            dark
            @click="HandlerSendAnswer"
            :disabled="evaluationScore !== '' || submittingAnswer"
            :loading="submittingAnswer"
          >
            Enviar
          </v-btn>
          <v-btn
            v-else
            color="#20B8D6"
            dark
            @click="HandlerSendAnswerCuestionary"
            :disabled="evaluationScore !== '' || submittingAnswer"
            :loading="submittingAnswer"
          >
            Enviar
          </v-btn>
        </v-card>
      </template>
      <div v-else class="minimal-no-content d-flex justify-center align-center">
        <v-alert outlined type="warning" prominent border="left">
          No posee este contenido.
        </v-alert>
      </div>
    </div>

    <QuestionsDialog
      v-if="!isMinimalView && data.id && data.module_id"
      :active="showQuestionsDialog"
      @dialog:change="showQuestionsDialog = $event"
      :lesson-id="data.id"
      :course-id="data.module_id"
      :schedule-id="this.schedule_id"
    />
    <AttachmentsDialog
      v-if="!isMinimalView && data.id"
      :active="showAttachmentsDialog"
      @dialog:change="showAttachmentsDialog = $event"
      :lesson-id="data.id"
      :schedule-id="this.schedule_id"
    />
    <v-dialog
      v-if="isBrandedNavView && data.id"
      v-model="showCommentsDialog"
      max-width="720"
      transition="slide-x-reverse-transition"
    >
      <ContentComments
        ref="brandedContentComments"
        v-model="commentary"
        compact
        :show-form="showCommentary"
        :comments="dataCommentaries"
        :loading="loadingCommentary"
        :can-load-more="canLoadMoreComments"
        :pagination="pagination"
        @update:show-form="showCommentary = $event"
        @submit="HandlerRegisterCommentary"
        @page-change="HandlerGetCommentary"
      />
    </v-dialog>
    <v-dialog
      v-if="isBrandedNavView && data.id"
      v-model="showRatingDialog"
      max-width="560"
      transition="slide-x-reverse-transition"
    >
      <ContentRating
        v-model="rating"
        compact
        :average="rating_general"
        :can-rating="canRating"
        :loading="loadingRating"
        @submit="HandlerRating"
      />
    </v-dialog>
    <v-dialog
      v-if="canUseVideoNotes"
      v-model="showNotesDialog"
      :content-class="notesDialogContentClass"
      max-width="620"
      transition="slide-x-reverse-transition"
    >
      <ContentNotes
        v-model="noteText"
        compact
        :allow-create="notesDialogMode === 'create'"
        :notes="videoNotes"
        :loading="loadingNotes"
        :pagination="notesPagination"
        :current-time="noteCaptureTime"
        @capture-time="refreshNoteTime"
        @submit="HandlerRegisterNote"
        @seek="seekToNote"
        @page-change="HandlerGetNotes"
      />
    </v-dialog>
    <v-dialog
      v-if="canUseVideoPolls"
      v-model="showPollsDialog"
      :persistent="Boolean(activePoll)"
      :content-class="pollsDialogContentClass"
      max-width="620"
      transition="slide-x-reverse-transition"
    >
      <ContentPolls
        v-model="selectedPollOption"
        compact
        :polls="videoPolls"
        :active-poll="activePoll"
        :answered-poll-ids="answeredPollIds"
        :poll-answers="pollAnswers"
        :result="activePollResult"
        @submit="submitActivePoll"
        @continue="closeActivePollResult"
      />
    </v-dialog>
    <CourseSidebar
      v-if="isBrandedNavView"
      v-model="showCourseSidebar"
      :brand-logo-url="brandLogoUrl"
      :module-name="data.module && data.module.name"
      :lesson-name="data.pill_name"
      :module-id="$route.query.module_id || data.module_id"
      :schedule-id="schedule_id"
      :current-lesson-id="data.id"
      :return-to="courseReturnTo"
      :questions-count="data.count_questions"
      :attachments-count="data.count_attachments"
      :notes-count="totalVideoNotes"
      :polls-count="videoPolls.length"
      :can-open-questions="Boolean(data.id && data.module_id)"
      :can-open-attachments="Boolean(data.id)"
      :can-open-comments="Boolean(data.id)"
      :can-open-rating="Boolean(data.id)"
      :can-open-notes="canUseVideoNotes"
      :show-polls-action="isVideoPollsFeatureEnabled"
      :can-open-polls="canUseVideoPolls"
      @open-questions="openSidebarQuestions"
      @open-attachments="openSidebarAttachments"
      @open-comments="openSidebarComments"
      @open-rating="openSidebarRating"
      @open-notes="openSidebarNotes"
      @open-polls="openSidebarPolls"
    >
      <template v-slot:questions>
        <ContentQuestions
          v-if="data.id && data.module_id"
          active
          compact
          :show-header="false"
          :lesson-id="data.id"
          :course-id="data.module_id"
          :schedule-id="schedule_id"
        />
      </template>

      <template v-slot:attachments>
        <ContentAttachments
          v-if="data.id"
          active
          compact
          :show-header="false"
          :lesson-id="data.id"
          :schedule-id="schedule_id"
        />
      </template>

      <template v-slot:comments>
        <ContentComments
          ref="sidebarContentComments"
          v-model="commentary"
          compact
          :show-form="showCommentary"
          :comments="dataCommentaries"
          :loading="loadingCommentary"
          :can-load-more="canLoadMoreComments"
          :pagination="pagination"
          @update:show-form="showCommentary = $event"
          @submit="HandlerRegisterCommentary"
          @page-change="HandlerGetCommentary"
        />
      </template>

      <template v-slot:rating>
        <ContentRating
          v-model="rating"
          compact
          :average="rating_general"
          :can-rating="canRating"
          :loading="loadingRating"
          @submit="HandlerRating"
        />
      </template>

      <template v-slot:notes>
        <ContentNotes
          v-model="noteText"
          compact
          :allow-create="false"
          :notes="videoNotes"
          :loading="loadingNotes"
          :pagination="notesPagination"
          :current-time="noteCaptureTime"
          @capture-time="refreshNoteTime"
          @submit="HandlerRegisterNote"
          @seek="seekToNote"
          @page-change="HandlerGetNotes"
        />
      </template>

      <template v-slot:polls>
        <ContentPolls
          v-if="isVideoPollsFeatureEnabled"
          v-model="selectedPollOption"
          compact
          :polls="videoPolls"
          :active-poll="null"
          :answered-poll-ids="answeredPollIds"
          :poll-answers="pollAnswers"
          @submit="submitActivePoll"
        />
      </template>
    </CourseSidebar>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment";
import ToolbarCore from "../core/Toolbar";
import fullscreen from "vue-fullscreen";
import Dashboard from "../DashboardFullScreen.vue";
import Vue from "vue";
import QuestionsDialog from './Questions/QuestionsDialog.vue'
import AttachmentsDialog from './Questions/AttachmentsDialog.vue'
import ContentAttachments from './Questions/ContentAttachments.vue'
import ContentComments from './Questions/ContentComments.vue'
import ContentQuestions from './Questions/ContentQuestions.vue'
import ContentRating from './Questions/ContentRating.vue'
import ContentNotes from './Questions/ContentNotes.vue'
import ContentPolls from './Questions/ContentPolls.vue'
import CourseSidebar from './CourseSidebar.vue'
import ShowContentMedia from './ShowContentMedia.vue'
import { isMinimalContentSubdomain, isBrandedNavContentSubdomain, getSubdomain } from '../../utils/embedSubdomains'
import { routeLocationWithoutDataRef } from '../../utils/stripDataRefFromRoute'
import { ENABLE_VIDEO_NOTES, ENABLE_VIDEO_POLLS } from '../../constants/featureFlags'
Vue.use(fullscreen);
export default {
  components: {
    "toolbar-core": ToolbarCore,
    "dashboard-new": Dashboard,
    QuestionsDialog,
    AttachmentsDialog,
    ContentAttachments,
    ContentComments,
    ContentQuestions,
    ContentRating,
    ContentNotes,
    ContentPolls,
    CourseSidebar,
    ShowContentMedia,
  },
  data() {
    return {
      file: "",
      content_id: "",
      schedule_id: "",
      time: "",
      data: {
        id: null,
        module_id: null
      },
      showNoContent: false,
      interval: "",
      file_type: "video",
      loading: false,
      public_key: null,
      can_see: false,
      fullscreen: false,

      // ** SECOND PART DEVELOP **
      loadingCommentary: false,
      showCommentary: false,
      loadingRating: false,
      commentary: "",
      rating: 0,
      rating_general: 0,
      canRating: false,
      canShowRating: false,
      dataCommentaries: [],
      serverCommentaries: [],
      pagination: {},
      commentsPerPage: 3,
      radioItem: null,
      answer: [],
      cuestionary: [],
      showRotationCt: true,
      showQuestionsDialog: false,
      showAttachmentsDialog: false,
      showCommentsDialog: false,
      showRatingDialog: false,
      showNotesDialog: false,
      showCourseSidebar: false,
      loadingNotes: false,
      videoNotes: [],
      notesPagination: {},
      notesPerPage: 4,
      noteText: "",
      noteCaptureTime: 0,
      notesDialogMode: 'view',
      showPollsDialog: false,
      videoPolls: [],
      answeredPollIds: [],
      pollAnswers: {},
      promptedPollIds: [],
      activePoll: null,
      selectedPollOption: null,
      activePollResult: null,
      videoCurrentTime: 0,
      navigationCompletedLessonKeys: [],
      evaluationScore: "",
      submittingAnswer: false,
      next_lesson: null,
      prev_lesson: null,
      return_to: null,
      isMinimalView: false,
      isBrandedNavView: false,
      brandLogoUrl: null,
      minimalFullscreenThrottle: null,
    };
  },

  computed: {
    isFullView() {
      return !this.isMinimalView && !this.isBrandedNavView;
    },
    brandedBodyNonVideoMargin() {
      return !this.loading && this.data.file_type && this.data.file_type !== 'video';
    },
    isMediaType() {
      const ft = this.data.file_type;
      return ft && ft !== 'test_content' && ft !== 'cuestionario' && ft !== 'articulo';
    },
    canLoadMoreComments() {
      return Boolean(
        this.pagination.last_page &&
          this.pagination.current_page &&
          this.pagination.last_page > this.pagination.current_page
      );
    },
    canUseVideoNotes() {
      return (
        ENABLE_VIDEO_NOTES &&
        Boolean(this.data.id && this.data.file_type === 'video')
      );
    },
    isVideoPollsFeatureEnabled() {
      return ENABLE_VIDEO_POLLS;
    },
    canUseVideoPolls() {
      return Boolean(
        ENABLE_VIDEO_POLLS &&
          this.data.id &&
          this.data.file_type === 'video' &&
          this.videoPolls.length > 0
      );
    },
    totalVideoNotes() {
      return Number(this.notesPagination.total || this.videoNotes.length);
    },
    currentLessonNavigationKey() {
      return this.navigationLessonKey(this.data);
    },
    nextLessonNavigationKey() {
      return this.navigationLessonKey(this.next_lesson);
    },
    hasCompletedCurrentLesson() {
      return Boolean(
        this.currentLessonNavigationKey &&
          this.navigationCompletedLessonKeys.includes(this.currentLessonNavigationKey)
      );
    },
    hasCompletedNextLesson() {
      return Boolean(
        this.nextLessonNavigationKey &&
          this.navigationCompletedLessonKeys.includes(this.nextLessonNavigationKey)
      );
    },
    canNavigateNextLesson() {
      return Boolean(
        this.next_lesson &&
          (this.hasCompletedCurrentLesson || this.hasCompletedNextLesson)
      );
    },
    notesDialogContentClass() {
      return this.$vuetify.breakpoint.xsOnly
        ? 'notes-dialog-content notes-dialog-content--mobile'
        : 'notes-dialog-content';
    },
    pollsDialogContentClass() {
      return this.$vuetify.breakpoint.xsOnly
        ? 'polls-dialog-content polls-dialog-content--mobile'
        : 'polls-dialog-content';
    },
    courseReturnTo() {
      if (this.return_to) {
        return this.return_to;
      }

      const query = {
        module_id: this.$route.query.module_id || this.data.module_id,
      };

      if (this.$route.query.level_id) {
        query.level_id = this.$route.query.level_id;
      }

      if (this.schedule_id) {
        query.schedule_id = this.schedule_id;
      }

      const queryString = new URLSearchParams(query).toString();
      return `/profileNew${queryString ? `?${queryString}` : ''}`;
    },
  },

  created() {
    this.isMinimalView = isMinimalContentSubdomain();
    this.isBrandedNavView = isBrandedNavContentSubdomain();
    const brand = getSubdomain();
    this.brandLogoUrl = `https://s3.amazonaws.com/assets.pilsala.com/brand_logos/${brand}.png`;
  },

  async mounted() {
    const cleanRoute = routeLocationWithoutDataRef(this.$route);
    if (cleanRoute) {
      await this.$router.replace(cleanRoute);
    }

    this.content_id = this.$route.query.index;
    this.public_key = this.$route.query.value;
    this.can_see = this.$route.query.v;
    this.schedule_id = this.$route.query.schedule_id;
    this.return_to = this.$route.query.return_to || null;

    await this.HandlerGetData(this.content_id);
    await this.HandlerGetNavigationProgress();
    this.HandlerGetPolls();
    if (this.canUseVideoNotes) {
      this.HandlerGetNotes(1);
    }
    this.HandlerCounter(); /* ENVIAR LA PETICION DEL TIEMPO CADA 10SEG*/
    if (this.isFullView) {
      this.HandlerGetCommentary(1);
    }

    setTimeout(() => {
      this.showRotationCt = false;
    }, 3000);
  },

  beforeDestroy() {
    clearInterval(this.interval);
    if (this.minimalFullscreenThrottle) {
      clearTimeout(this.minimalFullscreenThrottle);
    }
  },

  filters: {
    date(val) {
      return moment(val)
        .locale("es")
        .calendar();
    },
  },


  watch: {
    '$route.query.index'() {
      this.reloadFromRoute();
    }
  },

  methods: {
    goBack() {
      if (this.return_to) {
        // Si hay una ruta de retorno guardada, navegar a ella
        const urlParts = this.return_to.split('?');
        const path = urlParts[0];
        const queryString = urlParts[1];
        
        if (queryString) {
          const params = new URLSearchParams(queryString);
          const query = {};
          params.forEach((value, key) => {
            query[key] = value;
          });
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } else {
        // Fallback: volver a la ruta anterior del historial
        this.$router.go(-1);
      }
    },
    async reloadFromRoute() {
      try {
        this.loading = true;
        this.showNoContent = false;
        this.content_id = this.$route.query.index;
        this.public_key = this.$route.query.value;
        this.can_see = this.$route.query.v;
        this.schedule_id = this.$route.query.schedule_id;
        // Preservar return_to
        if (this.$route.query.return_to) {
          this.return_to = this.$route.query.return_to;
        }
        this.evaluationScore = "";
        this.answer = [];
        this.dataCommentaries = [];
        this.serverCommentaries = [];
        this.pagination = {};
        this.showCommentsDialog = false;
        this.showRatingDialog = false;
        this.showNotesDialog = false;
        this.videoNotes = [];
        this.notesPagination = {};
        this.noteText = "";
        this.noteCaptureTime = 0;
        this.notesDialogMode = 'view';
        this.showPollsDialog = false;
        this.videoPolls = [];
        this.answeredPollIds = [];
        this.pollAnswers = {};
        this.promptedPollIds = [];
        this.activePoll = null;
        this.selectedPollOption = null;
        this.activePollResult = null;
        this.videoCurrentTime = 0;
        this.navigationCompletedLessonKeys = [];

        await this.HandlerGetData(this.content_id);
        await this.HandlerGetNavigationProgress();
        this.HandlerGetPolls();
        if (this.canUseVideoNotes) {
          this.HandlerGetNotes(1);
        }
        if (this.isFullView) {
          this.HandlerGetCommentary(1);
        }
        try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {
          // continue regardless of error
        }
      } finally {
        this.loading = false;
      }
    },
    navigatePrevLesson() {
      if (!this.prev_lesson) return;
      const schedule_id = this.$route.query.schedule_id;
      const module_id = this.$route.query.module_id || this.data.module_id;
      const query = {
        index: this.prev_lesson.data_encrypt,
        value: this.prev_lesson.public_key,
        schedule_id: schedule_id,
        module_id: module_id
      };
      // Preservar return_to si existe
      if (this.return_to) {
        query.return_to = this.return_to;
      }
      this.$router.push({
        name: 'show_content',
        query: query
      });
    },
    navigateNextLesson() {
      if (!this.canNavigateNextLesson) return;
      const schedule_id = this.$route.query.schedule_id;
      const module_id = this.$route.query.module_id || this.data.module_id;
      const query = {
        index: this.next_lesson.data_encrypt,
        value: this.next_lesson.public_key,
        schedule_id: schedule_id,
        module_id: module_id
      };
      // Preservar return_to si existe
      if (this.return_to) {
        query.return_to = this.return_to;
      }
      this.$router.push({
        name: 'show_content',
        query: query
      });
    },
    navigationLessonKey(lesson) {
      if (!lesson) return '';

      return String(
        lesson.content_id ||
          lesson.id ||
          lesson.content?.id ||
          lesson.pill_name ||
          ''
      );
    },
    async HandlerGetNavigationProgress() {
      const moduleId = this.$route.query.module_id || this.data.module_id;
      if (!moduleId) {
        this.navigationCompletedLessonKeys = [];
        return;
      }

      try {
        const response = await this.$store.dispatch('profile/LIST_CONTENT_COMPLETE', {
          module_id: moduleId,
          schedule_id: this.schedule_id,
        });
        const lessons = response.data.data || [];
        this.navigationCompletedLessonKeys = lessons
          .map((lesson) => this.navigationLessonKey(lesson))
          .filter(Boolean);
      } catch (error) {
        this.navigationCompletedLessonKeys = [];
      }
    },
    markCurrentLessonCompletedForNavigation() {
      const currentKey = this.currentLessonNavigationKey;
      if (!currentKey || this.navigationCompletedLessonKeys.includes(currentKey)) return;

      this.navigationCompletedLessonKeys = [
        ...this.navigationCompletedLessonKeys,
        currentKey,
      ];
    },
    async handleVideoEnded() {
      const wasProgressSaved = await this.HandlerGetContent(this.getCurrentVideoTime());
      if (!wasProgressSaved) return;

      this.markCurrentLessonCompletedForNavigation();
      await this.HandlerGetNavigationProgress();
      this.markCurrentLessonCompletedForNavigation();
    },
    async HandlerAddFavorite() {
      try {
        if (this.data.whatsapp_accounts.length == 0) {
          return;
        } else {
          this.loading = true;
          const request = { content_id: this.data.id };
          const response = await this.$store.dispatch(
            "profile/LIST_CONTENT_FAVORITE",
            request
          );
          this.$emit("cardList:change", response.data.data);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    toggle() {
      const media = this.$refs.contentMedia;
      if (media && media.toggleFullscreen) {
        media.toggleFullscreen();
      }
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    onMinimalFullscreenChange(isFullscreen) {
      this.fullscreen = isFullscreen;
      if (!this.isMinimalView || this.data.file_type !== 'video' || isFullscreen) {
        return;
      }
      if (this.minimalFullscreenThrottle) {
        return;
      }
      this.minimalFullscreenThrottle = setTimeout(() => {
        this.minimalFullscreenThrottle = null;
        const media = this.$refs.contentMedia;
        if (media && media.enterMinimalFullscreen) {
          media.enterMinimalFullscreen();
        }
      }, 400);
    },
    enterMinimalVideoFullscreen() {
      this.$nextTick(() => {
        const media = this.$refs.contentMedia;
        if (media && media.enterMinimalFullscreen) {
          media.enterMinimalFullscreen();
        }
      });
    },
    async HandlerGetValue(item) {
      if (this.answer.length == 0) {
        this.answer.push({
          question_id: item.question_id,
          id: item.id,
        });
      } else {
        const questions_id = this.answer.find(
          (quest) => quest.question_id == item.question_id
        );

        if (questions_id == undefined) {
          this.answer.push({
            question_id: item.question_id,
            id: item.id,
          });
        } else {
          const index = this.answer.findIndex(
            (quest) => quest.question_id == item.question_id
          );
          console.log("editar", index);
          this.answer.splice(index, 1, {
            question_id: item.question_id,
            id: item.id,
          });
        }
      }

      console.log(this.answer);
    },

    async HandlerGetValueCuestionary(item) {
      if (this.answer.length == 0) {
        this.answer.push({
          question_id: item.question_id,
          id: item.id,
        });
      } else {
        const status = this.answer.some((index) => item.id == index.id);

        if (status == true) {
          const position = this.answer.findIndex(
            (index) => item.id == index.id
          );

          if (position !== -1) {
            this.answer.splice(position, 1);
          }
        } else {
          this.answer.push({
            question_id: item.question_id,
            id: item.id,
          });
        }
      }

      console.log(this.answer);
    },

    async HandlerSendAnswer() {
      if (this.submittingAnswer) return;
      this.submittingAnswer = true;
      try {
        let arrays = [];
        for (const iterator of this.answer) {
          arrays.push(iterator.id);
        }

        const request = {
          content_id: this.data.id,
          answers: arrays,
        };
        const response = await this.$store.dispatch(
          "ratings/ANSWER_TEST",
          request
        );

        if (response.data.percentaje < 50) {
          Swal.fire({
            title: `<strong>${response.data.percentaje.toString()}%</strong>`,
            icon: "info",
            html:
              "No has alcanzado el mínimo de aprobación, puedes volverlo a intentar",
            showCloseButton: false,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: "Ok",
          });
        } else if (response.data.percentaje < 50) {
          Swal.fire({
            title: `<strong>${response.data.percentaje.toString()}%</strong>`,
            icon: "info",
            html: "? Estas cerca!, sigue intentando.",
            showCloseButton: false,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: "Ok",
          });
        } else if (
          response.data.percentaje > 49 &&
          response.data.percentaje < 79
        ) {
          Swal.fire({
            title: `<strong>${response.data.percentaje.toString()}%</strong>`,
            icon: "success",
            html: "? Estas cerca!, sigue intentando.",
            showCloseButton: false,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: "Ok",
          });
        } else if (response.data.percentaje > 79) {
          Swal.fire({
            title: `<strong>${response.data.percentaje.toString()}%</strong>`,
            icon: "success",
            html:
              "? Excelente!  Has respondido correctamente. Estás listo para otro módulo de PILSA, tu coach educativo",
            showCloseButton: false,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: "Ok",
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.submittingAnswer = false;
      }
    },

    async HandlerSendAnswerCuestionary() {
      if (this.submittingAnswer) return;
      this.submittingAnswer = true;
      try {
        let arrays = [];
        for (const iterator of this.answer) {
          arrays.push(iterator.id);
        }

        const request = {
          content_id: this.data.id,
          schedule_id: this.schedule_id,
          answers: arrays,
        };

        await this.$store.dispatch(
          "ratings/ANSWER_CUESTIONARY",
          request
        );

        Swal.fire({
          title: "Cuestionario finalizado",
          icon: "success",
          html: "Sus respuestas fueron registradas con exito ",
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: "Ok",
        });

        // Limpiar radios y checkboxes
      
        this.answer = []; // Limpiar respuestas seleccionadas
      } catch (error) {
        // console.log(error.response.status);
        // const array = []}}
       
        this.answer = [];

        if (error.response.status === 502) {
          Swal.fire({
            title: "Oh Oh",
            icon: "warning",
            html: error.response.data.message,
            showCloseButton: false,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: "Ok",
          });
        } else if (error.response.status === 503) {
          Swal.fire({
            title: "Lo siento",
            icon: "warning",
            html: error.response.data.message,
            showCloseButton: false,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: "Ok",
          });
        }
      } finally {
        this.submittingAnswer = false;
      }
    },

    async HandlerGetData(content_id) {
      this.loading = true;

      let decryptedPublicKey = this.public_key;
      if (this.public_key == undefined) {
        const storedKey = sessionStorage.getItem("Value-rec");
        if (storedKey) {
          decryptedPublicKey = this.CryptoJS.AES.decrypt(
            storedKey,
            "MyEncrypt-dAtA-sEcrEt"
          ).toString(this.CryptoJS.enc.Utf8);
        } else {
          decryptedPublicKey = null;
        }
      }

      const request = {
        index: content_id.replaceAll(" ", "+"),
        v: this.can_see == undefined ? null : this.can_see,
        schedule_id: this.schedule_id,
      };

      if (decryptedPublicKey) {
        request.public_key = decryptedPublicKey.replaceAll(" ", "+");
      }

      try {
        const response = await this.$store.dispatch(
          "profile/DESECRYPT_CONTENT",
          request
        );

        this.rating_general = response.data.score_avg;

        this.canRating = response.data.status_score;
        this.evaluationScore = response.data.evaluation_score;
        if (response.data.status_score == true)
          this.rating = response.data.score_user;

        const responseData = response.data.data;
        console.log('lesson_id',responseData.id);
        console.log('module_id',responseData.module_id);

        this.data = responseData;
        
        // Logs para verificar resoluciones
        console.log('=== DEBUG RESOLUCIONES ===');
        console.log('data.file_type:', this.data.file_type);
        console.log('data.video:', this.data.video);
        console.log('data.video.resolutions:', this.data.video?.resolutions);
        console.log('data.video.original_url:', this.data.video?.original_url);
        console.log('data.file_upload:', this.data.file_upload);
        if (this.data.video && this.data.video.resolutions && Array.isArray(this.data.video.resolutions)) {
          console.log('Cantidad de resoluciones:', this.data.video.resolutions.length);
          this.data.video.resolutions.forEach((resolution, index) => {
            console.log(`Resoluci?n ${index + 1}:`, {
              quality: resolution.quality,
              url: resolution.url,
              width: resolution.width,
              height: resolution.height,
              label: resolution.label
            });
          });
        } else {
          console.log('No hay resoluciones disponibles');
        }
        console.log('=== FIN DEBUG RESOLUCIONES ===');
        
        // Capturar navegación de lecciones
        this.next_lesson = response.data.next_lesson || null;
        this.prev_lesson = response.data.prev_lesson || null;

        // Marcar radios y checkboxes según answer_whatsapp_account
        if (this.data.question) {
          this.data.question.forEach((item) => {
            // Para radios
            if (item.question_type === 'single_selection') {
              const selected = item.answers.find(
                ans => Array.isArray(ans.answer_whatsapp_account) && ans.answer_whatsapp_account.length > 0
              );
              if (selected) {
                item.created_at = selected.id;
              }
            }
            // Para checkboxes
            if (item.question_type === 'multiple_selection') {
              item.answers.forEach(ans => {
                if (Array.isArray(ans.answer_whatsapp_account) && ans.answer_whatsapp_account.length > 0) {
                  ans.checkbox = true;
                }
              });
            }
          });
        }

        if (this.isMinimalView && this.data.file_type === 'video') {
          this.enterMinimalVideoFullscreen();
        }
      } catch (error) {
        console.log(error);
        if (error.response?.status == 403) {
          this.showNoContent = true;
        } else if (error.response?.status == 410) {
          // Contenido expirado - redirigir al perfil
          this.$snotify.error(
            error.response.data.message || "Este curso ha expirado y ya no está disponible para acceso.",
            "Acceso Expirado"
          );
          this.$router.push('/profile');
          return; // Salir temprano para evitar que se ejecute el finally
        }
      } finally {
        this.loading = false;
      }
    },

    async HandlerGetContent(time) {
      try {
        const request = {
          schedule_id: this.schedule_id,
          content_id: this.data.id,
          time: time || 0,
        };
        await this.$store.dispatch("profile/GET_SHOW_CONTENT_NEW", request);
        return true;
      } catch (error) {
        console.log('call HandlerGetContent');
        console.log(error);
        return false;
      }
    },

    HandlerCounter() {
      let value = 0;
      this.interval = setInterval(() => {
        if (value % 10 == 0) {
          this.time = value;
          this.HandlerGetContent(10);
        }
        value++;
      }, 1000);
    },

    // *** SEGUNDA PARTE DEVELOP ***
    async HandlerRegisterCommentary() {
      try {
        this.loadingCommentary = true;
        const commentBody = this.commentary.trim();
        const request = {
          body: commentBody,
          module_id: this.data.module_id,
          content_id: this.data.id,
        };

        const response = await this.$store.dispatch(
          "ratings/REGISTER_COMMENTARY",
          request
        );

        this.$snotify.success(
          `${response.data.message}, en espera de aprobación`,
          "Exitos!"
        );
        this.commentary = "";
        this.showCommentary = false;
        const commentsPanel = this.$refs.contentComments ||
          this.$refs.brandedContentComments ||
          this.$refs.sidebarContentComments;
        if (commentsPanel && commentsPanel.resetValidation) {
          commentsPanel.resetValidation();
        }
        await this.HandlerGetCommentary(1);
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingCommentary = false;
      }
    },

    async HandlerGetCommentary(page = 1) {
      try {
        this.loadingCommentary = true;
        const perPage = Number(this.commentsPerPage);
        const request = {
          page,
          content_id: this.data.id,
          per_page: perPage,
        };

        const response = await this.$store.dispatch(
          "ratings/GET_COMMENTARY",
          request
        );
        const responseData = response.data.data || {};
        this.serverCommentaries = responseData.data || [];
        this.dataCommentaries = this.serverCommentaries;
        this.pagination = {
          ...responseData,
          current_page: Number(responseData.current_page || page),
          last_page: Number(responseData.last_page || 1),
          per_page: Number(responseData.per_page || perPage),
          total: Number(responseData.total || this.serverCommentaries.length),
          from: Number(responseData.from || (this.serverCommentaries.length ? 1 : 0)),
          to: Number(responseData.to || this.serverCommentaries.length),
        };
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingCommentary = false;
      }
    },

    HandlerMore() {
      if (this.pagination.last_page > this.pagination.current_page) {
        this.HandlerGetCommentary(this.pagination.current_page + 1);
      } else {
        this.$snotify.warning(
          "Ya no hay mas elementos para mostrar",
          "Alerta!"
        );
      }
    },

    HandlerRedirect(url) {
      window.open(url, "_blank");
    },

    async HandlerRating() {
      try {
        this.loadingRating = true;
        const request = {
          score: this.rating,
          module_id: this.data.module_id,
          content_id: this.data.id,
        };
        const response = await this.$store.dispatch(
          "ratings/REGISTER_SCORE",
          request
        );
        this.$snotify.success(response.data.message, "Exitos!");
        this.canRating = true;
        this.rating_general = response.data.data_score;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingRating = false;
      }
    },

    closeSupportDialogs(except = null) {
      if (except !== 'questions') this.showQuestionsDialog = false;
      if (except !== 'attachments') this.showAttachmentsDialog = false;
      if (except !== 'comments') this.showCommentsDialog = false;
      if (except !== 'rating') this.showRatingDialog = false;
      if (except !== 'notes') this.showNotesDialog = false;
      if (except !== 'polls') this.showPollsDialog = false;
    },

    openQuestions() {
      if (this.data.id && this.data.module_id) {
        this.closeSupportDialogs('questions');
        this.showQuestionsDialog = true;
      } else {
        this.$snotify.warning('No se puede abrir el diálogo de preguntas en este momento');
      }
    },
    openAttachments() {
      if (this.data.id) {
        this.closeSupportDialogs('attachments');
        this.showAttachmentsDialog = true;
      } else {
        this.$snotify.warning('No se puede abrir el diálogo de archivos adjuntos en este momento');
      }
    },
    openComments() {
      if (!this.data.id) {
        this.$snotify.warning('No se pueden abrir los comentarios en este momento');
        return;
      }
      this.closeSupportDialogs('comments');
      this.showCommentsDialog = true;
      this.HandlerGetCommentary(1);
    },
    openRating() {
      if (!this.data.id) {
        this.$snotify.warning('No se puede abrir la calificacion en este momento');
        return;
      }
      this.closeSupportDialogs('rating');
      this.showRatingDialog = true;
    },
    openNotes() {
      if (!this.canUseVideoNotes) {
        this.$snotify.warning('Las notas solo estan disponibles para videos');
        return;
      }
      this.notesDialogMode = 'view';
      this.closeSupportDialogs('notes');
      this.HandlerGetNotes(this.notesPagination.current_page || 1);
      this.showNotesDialog = true;
    },
    openNoteComposer() {
      if (!this.canUseVideoNotes) return;

      this.notesDialogMode = 'create';
      this.closeSupportDialogs('notes');
      this.refreshNoteTime();
      this.pauseVideo();
      this.showNotesDialog = true;
    },
    openPolls() {
      if (!this.canUseVideoPolls) {
        this.$snotify.warning('Las encuestas solo estan disponibles para videos');
        return;
      }

      this.activePoll = null;
      this.selectedPollOption = null;
      this.closeSupportDialogs('polls');
      this.showPollsDialog = true;
    },
    openSidebarQuestions() {
      this.closeSupportDialogs();
    },
    openSidebarAttachments() {
      this.closeSupportDialogs();
    },
    openSidebarComments() {
      if (!this.data.id) return;

      this.closeSupportDialogs();
      this.HandlerGetCommentary(1);
    },
    openSidebarRating() {
      if (!this.data.id) return;

      this.closeSupportDialogs();
    },
    openSidebarNotes() {
      if (!this.canUseVideoNotes) return;

      this.notesDialogMode = 'view';
      this.closeSupportDialogs();
      this.refreshNoteTime();
      this.HandlerGetNotes(this.notesPagination.current_page || 1);
    },
    openSidebarPolls() {
      if (!this.canUseVideoPolls) return;

      this.activePoll = null;
      this.selectedPollOption = null;
      this.closeSupportDialogs();
    },
    getCurrentVideoTime() {
      const media = this.$refs.contentMedia;
      if (media && typeof media.getCurrentTime === 'function') {
        const t = media.getCurrentTime();
        if (Number.isFinite(t) && t > 0) return t;
      }
      return Number(this.videoCurrentTime) || 0;
    },
    refreshNoteTime() {
      this.noteCaptureTime = this.getCurrentVideoTime();
    },
    pauseVideo() {
      const media = this.$refs.contentMedia;
      if (media && typeof media.pauseVideo === 'function') {
        media.pauseVideo();
      }
    },
    playVideo() {
      const media = this.$refs.contentMedia;
      if (media && typeof media.playVideo === 'function') {
        media.playVideo();
      }
    },
    videoPollAnswersStorageKey() {
      return [
        'video-polls',
        this.schedule_id || 'without-schedule',
        this.data.id || this.content_id || 'without-content',
      ].join(':');
    },
    extractVideoPollsFromContent() {
      const candidates = [
        this.data.video?.polls,
        this.data.video?.video_polls,
        this.data.polls,
        this.data.video_polls,
        this.data.encuestas,
      ];

      return candidates.find((candidate) => Array.isArray(candidate)) || [];
    },
    normalizeVideoPolls(polls) {
      return polls
        .map((poll, index) => {
          let options = [];
          if (Array.isArray(poll.options)) {
            options = poll.options;
          } else if (Array.isArray(poll.answers)) {
            options = poll.answers;
          }
          const required = String(poll.required).toLowerCase();
          const timeSeconds = Number(
            poll.time_seconds ||
              poll.time ||
              poll.seconds ||
              poll.second ||
              poll.at_second ||
              0
          );

          return {
            ...poll,
            id: poll.id || poll.poll_id || `${this.data.id}-poll-${index + 1}`,
            content_id: poll.content_id || this.data.id,
            time_seconds: timeSeconds,
            required: poll.required === true || ['1', 'true', 'yes'].includes(required),
            type: poll.type || poll.question_type || 'single',
            question: poll.question || poll.name || poll.title || '',
            options: options.map((option) => ({
              ...option,
              id: option.id || option.value,
              text: option.text || option.name || option.label || option.answer || '',
            })),
          };
        })
        .filter((poll) => poll.id && poll.question && Number.isFinite(poll.time_seconds));
    },
    buildMockVideoPolls() {
      if (!this.data.id || this.data.file_type !== 'video') return [];

      return [
        {
          id: `${this.data.id}-poll-1`,
          content_id: this.data.id,
          time_seconds: 15,
          required: true,
          type: 'single',
          question: 'Que idea principal se explico en este primer momento?',
          correct_option_id: 'a',
          options: [
            { id: 'a', text: 'Identificar el concepto central antes de avanzar' },
            { id: 'b', text: 'Saltar directamente al siguiente contenido' },
            { id: 'c', text: 'Responder sin revisar el ejemplo' },
          ],
        },
        {
          id: `${this.data.id}-poll-2`,
          content_id: this.data.id,
          time_seconds: 45,
          required: true,
          type: 'multiple',
          question: 'Que deberia hacer el estudiante despues de ver el ejemplo?',
          correct_option_ids: ['a', 'c'],
          options: [
            { id: 'a', text: 'Aplicar el procedimiento con sus propios datos' },
            { id: 'b', text: 'Cerrar el video sin practicar' },
            { id: 'c', text: 'Revisar que el resultado coincida con el objetivo' },
          ],
        },
        {
          id: `${this.data.id}-poll-3`,
          content_id: this.data.id,
          time_seconds: 90,
          required: true,
          type: 'open',
          question: 'Cual es la mejor forma de comprobar que el aprendizaje quedo claro?',
          options: [],
        },
      ];
    },
    HandlerGetPolls() {
      if (!ENABLE_VIDEO_POLLS || this.data.file_type !== 'video') {
        this.videoPolls = [];
        this.answeredPollIds = [];
        this.pollAnswers = {};
        this.promptedPollIds = [];
        this.activePoll = null;
        this.selectedPollOption = null;
        this.activePollResult = null;
        return;
      }

      const contentPolls = this.normalizeVideoPolls(this.extractVideoPollsFromContent());
      this.videoPolls = contentPolls.length ? contentPolls : this.buildMockVideoPolls();
      this.promptedPollIds = [];
      this.activePoll = null;
      this.selectedPollOption = null;
      this.activePollResult = null;

      try {
        const storedAnswers = localStorage.getItem(this.videoPollAnswersStorageKey());
        const parsedAnswers = storedAnswers ? JSON.parse(storedAnswers) : null;

        if (Array.isArray(parsedAnswers)) {
          this.answeredPollIds = parsedAnswers;
          this.pollAnswers = {};
        } else {
          this.answeredPollIds = parsedAnswers && Array.isArray(parsedAnswers.answeredPollIds)
            ? parsedAnswers.answeredPollIds
            : [];
          this.pollAnswers = parsedAnswers && parsedAnswers.answers
            ? parsedAnswers.answers
            : {};
        }
      } catch (error) {
        this.answeredPollIds = [];
        this.pollAnswers = {};
      }
    },
    persistVideoPollAnswers() {
      try {
        localStorage.setItem(this.videoPollAnswersStorageKey(), JSON.stringify({
          answeredPollIds: this.answeredPollIds,
          answers: this.pollAnswers,
        }));
      } catch (error) {
        this.$snotify.warning('No se pudieron guardar las respuestas locales');
      }
    },
    handleVideoTimeUpdate(seconds) {
      this.videoCurrentTime = seconds;
      if (!this.canUseVideoPolls || this.showPollsDialog || this.activePoll) return;

      const answeredPollIds = this.answeredPollIds.map(String);
      const promptedPollIds = this.promptedPollIds.map(String);
      const pendingPoll = this.videoPolls.find((poll) => {
        return (
          poll.required &&
          Number(poll.time_seconds) <= Number(seconds) &&
          !answeredPollIds.includes(String(poll.id)) &&
          !promptedPollIds.includes(String(poll.id))
        );
      });

      if (!pendingPoll) return;

      this.promptedPollIds = [...this.promptedPollIds, String(pendingPoll.id)];
      this.activePoll = pendingPoll;
      this.selectedPollOption = pendingPoll.type === 'multiple' ? [] : null;
      this.activePollResult = null;
      this.closeSupportDialogs('polls');
      this.pauseVideo();
      this.showPollsDialog = true;
    },
    submitActivePoll() {
      if (!this.activePoll || !this.hasPollAnswer(this.selectedPollOption)) return;

      const activePollId = String(this.activePoll.id);
      this.pollAnswers = {
        ...this.pollAnswers,
        [activePollId]: this.selectedPollOption,
      };
      this.activePollResult = {
        isCorrect: this.isPollAnswerCorrect(this.activePoll, this.selectedPollOption),
      };

      if (!this.answeredPollIds.map(String).includes(activePollId)) {
        this.answeredPollIds = [...this.answeredPollIds, activePollId];
        this.persistVideoPollAnswers();
      }

    },
    closeActivePollResult() {
      this.activePoll = null;
      this.selectedPollOption = null;
      this.activePollResult = null;
      this.showPollsDialog = false;
      this.playVideo();
    },
    hasPollAnswer(answer) {
      if (Array.isArray(answer)) return answer.length > 0;
      return answer !== null && answer !== undefined && String(answer).trim().length > 0;
    },
    isPollAnswerCorrect(poll, answer) {
      if (poll.type === 'multiple') {
        const selectedIds = (Array.isArray(answer) ? answer : []).map(String).sort();
        const correctIds = (poll.correct_option_ids || []).map(String).sort();
        return selectedIds.length === correctIds.length
          && selectedIds.every((id, index) => id === correctIds[index]);
      }

      if (poll.type === 'open') {
        return null;
      }

      return String(answer) === String(poll.correct_option_id);
    },
    videoNotesStorageKey() {
      return [
        'mock-video-notes',
        this.schedule_id || 'without-schedule',
        this.data.id || this.content_id || 'without-content',
      ].join(':');
    },
    persistMockVideoNotes() {
      try {
        localStorage.setItem(this.videoNotesStorageKey(), JSON.stringify(this.videoNotes));
      } catch (error) {
        this.$snotify.warning('No se pudieron guardar las notas locales');
      }
    },
    HandlerGetNotes() {
      if (!this.canUseVideoNotes) return;

      try {
        this.loadingNotes = true;
        const storedNotes = localStorage.getItem(this.videoNotesStorageKey());
        this.videoNotes = storedNotes ? JSON.parse(storedNotes) : [];
        this.notesPagination = {};
      } catch (error) {
        this.videoNotes = [];
        this.notesPagination = {};
        this.$snotify.error('No se pudieron cargar las notas locales del video');
      } finally {
        this.loadingNotes = false;
      }
    },
    HandlerRegisterNote() {
      const body = this.noteText.trim();
      if (!body) return;

      try {
        this.loadingNotes = true;
        const capturedTime = Number.isFinite(this.noteCaptureTime) && this.noteCaptureTime > 0
          ? this.noteCaptureTime
          : this.getCurrentVideoTime();

        const note = {
          id: `mock-note-${Date.now()}`,
          content_id: this.data.id,
          schedule_id: this.schedule_id,
          time_seconds: capturedTime,
          second: capturedTime,
          time: capturedTime,
          note: body,
          created_at: new Date().toISOString(),
        };

        this.videoNotes = [note, ...this.videoNotes];
        this.persistMockVideoNotes();
        this.$snotify.success('Nota creada correctamente', 'Exitos!');
        this.noteText = "";
        this.notesDialogMode = 'view';
      } catch (error) {
        this.$snotify.error('No se pudo guardar la nota local del video');
      } finally {
        this.loadingNotes = false;
      }
    },
    seekToNote(note) {
      const media = this.$refs.contentMedia;
      if (media && typeof media.seekToTime === 'function') {
        media.seekToTime(note.time_seconds);
      }
      this.showNotesDialog = false;
      this.showCourseSidebar = false;
    },
    goToCourseContent() {
      this.showCourseSidebar = false;

      if (this.return_to) {
        const urlParts = this.return_to.split('?');
        const path = urlParts[0];
        const queryString = urlParts[1];

        if (queryString) {
          const query = {};
          const params = new URLSearchParams(queryString);
          params.forEach((value, key) => {
            query[key] = value;
          });
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
        return;
      }

      const query = {
        module_id: this.$route.query.module_id || this.data.module_id,
      };

      const levelId = this.$route.query.level_id || this.data.level_id || this.data.level;
      if (levelId) {
        query.level_id = levelId;
      }

      if (this.schedule_id) {
        query.schedule_id = this.schedule_id;
      }

      this.$router.push({
        name: 'detail_module',
        query,
      });
    },
  },
};
</script>

<style scoped>
@media (max-width: 1024px) {
  .classContainerBodySlot {
    width: 100% !important;
    padding: 1rem !important;
    margin-left: 0 !important;
  }
}

@media (max-width: 500px) {
  .headerInsideShowContentDad {
    justify-content: center !important;
  }
}
.classForceSizeTitle {
  margin: 2rem 0;
}

.support-section {
  margin-top: 12px;
  padding-bottom: 28px;
}

.support-section .col {
  padding-top: 8px;
  padding-bottom: 8px;
}

.white-10 {
  background-color: #a4a4a438;
}

.circleIcon {
  width: 35px;
  height: 35px;
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  /* overflow: hidden; */
  border-radius: 100px;
  padding: 5px;
  justify-content: center;
}
.headerInsideShowContentDad {
  display: flex;
  justify-content: space-between;
  margin: 0 1rem;
  /* flex-wrap: wrap-reverse; */
  width: calc(100% - 1rem);
  /* align-items: flex-start; */
  /* background-color: red; */
}
.headerInsideShowContent_timestamp {
  text-align: left;
  font: normal normal 300 14px/21px Poppins;
  letter-spacing: 0px;
  color: #8a98a5;
  margin-left: 16px;
}
.headerInsideShowContent_title {
  /* max-width: 215px; */
  margin-bottom: 1rem;

  /* width: 30%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
  /* margin-bottom: 0.5rem; */
  text-align: left;
  font: normal normal bold 18px/27px Poppins;
  letter-spacing: 0px;
  color: #101820;
}
  .btnEditProfile2 {
    display: block !important;
    position: unset !important;
  }

  .btnEditProfile2 {
  background: #f6f6f6 0% 0% no-repeat padding-box;
  border-radius: 21px;
  opacity: 1;
  padding: 8px 24px;
  position: relative;
  font: normal normal normal 13px/26px Poppins;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btnEditProfile2:hover {
  background: #e9ecef;
}

.btnEditProfile2:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btnEditProfile2 .v-icon {
  font-size: 18px;
}
.headerInsideShowContent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
}

.headerInsideShowContent2 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.headerInsideShowContent2 .btnEditProfile2 span {
    color: #101820;
    font-weight: bold;
}

.buttons-container {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.headerInsideShowContent_timestamp {
  text-align: right;
  font: normal normal 300 14px/21px Poppins;
  letter-spacing: 0px;
  color: #8a98a5;
  margin-left: 0;
}
.stylingContainerDynamic {
  background-color: white !important;
  box-shadow: none !important;
  padding: 1rem;
  width: 100%;
}

.rotation-ct {
  z-index: 995;
  position:absolute;
  background: #0000006b;
  height: 100%;
  width: 100%;
}

.rotation-item {
  position: relative; height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.phone {
  height: 50px;
  width: 100px;
  border: 3px solid white;
  border-radius: 10px;
  animation: rotate 1.5s ease-in-out infinite alternate;
  /* display: none; */
}

.message {
  color: white;
  font-size: 1em;
  margin-top: 40px;
  /* display: none; */
}

@keyframes rotate {
  0% {
		transform: rotate(0deg)
	}
	50% {
		transform: rotate(-90deg)
	}
	100% {
		transform: rotate(-90deg)
	}
}

.fullscreen-align-right {
  position: absolute;
  top: 4px;
  z-index: 999;
  left: 5px;
  background-color: #12121280!important;
  border-radius: 8px;
  color: #f9f8fc;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
}

.hide-fullscreen-btn {
  display: none;
}


@media only screen and (max-device-width: 812px) and (orientation: landscape) {
  .phone, .message {
    display: block;
  }
}

@media only screen and (max-width: 768px) and (orientation: portrait) {
  .showRotationCt {
    display: block;
  }
}

@media only screen and (max-width: 768px) and (orientation: landscape) {
  .showRotationCt {
    display: none;
  }
}

.container {
    margin-left: 0px;
}


/* Barra de navegación entre lecciones */
.nav-lessons-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 2rem 1rem;
  border-color: rgb(238, 238, 238);
  background-color: white;
}

/* Botón con estilo de "Ver Ahora" */
.containerBtn--seeRigthNow {
  background: #0076ff 0% 0% no-repeat padding-box;
  border-radius: 32px;
  text-align: center;
  font: normal normal normal 13px/30px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  padding: 9px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Ocultar textos de botones en mobile */
.btn-nav-text {
  display: none;
}

/* Ajustar márgenes de iconos en mobile */
.btn-nav-left .mr-2,
.btn-nav-right .ml-2 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

button:disabled.containerBtn--seeRigthNow {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Estilos para tablets en adelante (768px+) */
@media (min-width: 768px) {
  .btn-nav-left,
  .btn-nav-right {
    min-width: 140px;
  }

  .btn-nav-text {
    display: inline;
  }

  /* Restaurar márgenes en tablets */
  .btn-nav-left .mr-2 {
    margin-right: 0.5rem !important;
  }

  .btn-nav-right .ml-2 {
    margin-left: 0.5rem !important;
  }
}

/* Ocultar navegación hasta habilitar en producción */
.nav-lessons-bar {
  /*  display: none;  */
}

/* Contenedor de video con aspect-ratio fijo para evitar resize */
.video-player-container {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
  min-height: 400px;
}

.video-player-container .plyr {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-player-container video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.minimal-root {
  overflow: hidden;
}

.minimal-content-view {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: #000;
  overflow: auto;
}

.minimal-page-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.minimal-no-content {
  width: 100vw;
  height: 100vh;
  background: #fff;
}

.minimal-quiz {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
}

.minimal-articulo {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
}

.branded-root {
  overflow: hidden;
}

.branded-content-view {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
}

.branded-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 24px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
}

.branded-support-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 1 auto;
  min-width: 0;
}

.lesson-action-chip {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 7px 14px;
  border: 0;
  border-radius: 21px;
  background: #f6f6f6;
  color: #101820;
  cursor: pointer;
  font: normal normal 500 12px/18px Poppins;
  white-space: nowrap;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.lesson-action-chip:hover {
  background: #e9f7fb;
  color: #0076ff;
}

.lesson-action-chip:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.lesson-action-chip .v-icon {
  color: currentColor;
}

.video-note-trigger {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: 0;
  border-radius: 999px;
  background: #0076ff;
  color: #fff;
  box-shadow: 0 8px 18px rgba(0, 118, 255, 0.28);
  cursor: pointer;
  font: normal normal 700 12px/18px Poppins;
}

.video-note-trigger:hover {
  background: #0066dc;
}

.video-note-trigger .v-icon {
  color: currentColor;
}

::v-deep .notes-dialog-content {
  border-radius: 8px;
  overflow: hidden;
}

::v-deep .notes-dialog-content--mobile {
  align-self: flex-end;
  width: 100%;
  max-width: 100%;
  margin: 0;
  border-radius: 18px 18px 0 0;
}

::v-deep .polls-dialog-content {
  border-radius: 8px;
  overflow: hidden;
}

::v-deep .polls-dialog-content--mobile {
  align-self: flex-end;
  width: 100%;
  max-width: 100%;
  margin: 0;
  border-radius: 18px 18px 0 0;
}

.branded-header-left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1 1 auto;
}

.course-menu-button {
  color: #101820;
}

.course-menu-button:hover {
  background: #e9f7fb;
  color: #0076ff;
}

.branded-header-titles {
  min-width: 0;
}

.branded-lesson-name {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: #101820;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.branded-module-name {
  margin: 2px 0 0;
  font-size: 0.85rem;
  color: #6b7280;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.branded-logo {
  width: 180px;
  flex: 0 0 auto;
}

.branded-body {
  flex: 1 1 auto;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  padding: 0px;
  position: relative;
  min-height: 0;
  width: 100%;
  background: #fff;
}

.branded-body--non-video {
  margin-bottom: 35px;
}

.branded-body > * {
  width: 100%;
  height: 100%;
}

.branded-body .video-player-container {
  max-width: none;
  width: 100%;
  height: 100%;
}

.branded-nav-bar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #fff;
  border-top: 1px solid #e8e8e8;
}

.branded-mobile-video-nav {
  display: none;
  width: auto;
  height: auto;
}

.branded-mobile-video-nav__button {
  width: 36px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: #0076ff;
  color: #fff;
  box-shadow: 0 8px 18px rgba(16, 24, 32, 0.22);
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.branded-mobile-video-nav__button:hover {
  transform: translateY(-1px);
}

.branded-mobile-video-nav__button:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.branded-mobile-video-nav__button .v-icon {
  color: currentColor;
}

.branded-mobile-video-nav__button--prev {
  border-radius: 0 8px 8px 0;
}

.branded-mobile-video-nav__button--next {
  border-radius: 8px 0 0 8px;
}

@media (max-width: 1100px) {
  .branded-header {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .branded-support-actions {
    order: 3;
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
    padding-left: 48px;
  }
}

@media (max-width: 640px) {
  .branded-header {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 44px;
    align-items: center;
    gap: 10px;
    padding: 10px 12px 9px;
  }

  .branded-header-left {
    width: 100%;
    display: grid;
    grid-template-columns: 44px minmax(0, 1fr);
    align-items: center;
    gap: 8px;
  }

  .branded-back-button,
  .course-menu-button {
    width: 44px !important;
    height: 44px !important;
    margin-right: 0 !important;
  }

  .branded-back-button .v-icon,
  .course-menu-button .v-icon {
    font-size: 27px !important;
  }

  .branded-header-titles {
    min-width: 0;
  }

  .branded-lesson-name {
    font-size: 1rem;
    line-height: 1.2;
    display: -webkit-box;
    overflow: hidden;
    white-space: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .branded-module-name {
    max-width: 100%;
    margin-top: 2px;
    font-size: 0.78rem;
    line-height: 1.2;
  }

  .branded-logo {
    display: none;
  }

  .branded-support-actions {
    display: none;
  }

  .video-note-trigger {
    width: 40px;
    min-height: 40px;
    padding: 0;
  }

  .video-note-trigger span {
    display: none;
  }

  .branded-nav-bar {
    display: none;
  }

  .branded-mobile-video-nav {
    pointer-events: none;
    position: fixed;
    inset: 0;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .branded-mobile-video-nav__button {
    pointer-events: auto;
  }
}

</style>

